import React from 'react';

import useFetchFeedItems from '../../../../hooks/useFetchFeedItems';
import EmptyStateCard from '../../../../components/EmptyStateCard';
import ListingsList from '../../../../components/ListingsList';
import trackEvent from '../../../../utils/trackEvent';
import { TFeedRequest, TSection } from '../../../../types/TConfigurablePage';
import { getCookie } from '../../../../utils/cookies';

type TProps = {
  feedRequest: TFeedRequest;
  visualization: TSection['content']['visualization'];
};

const trackClickFeedItem = (feedType) => {
  trackEvent({ eventAction: 'ClickListing', eventLabel: feedType });
};

const FeedItems = ({ feedRequest, visualization }: TProps) => {
  const { listings, isLoading, isError, isEmpty } = useFetchFeedItems({
    feedType: feedRequest.feedType,
    limit: feedRequest.limit,
    offset: feedRequest.offset,
    postcode: feedRequest.feedType === 'NEARBY' ? getCookie('pc') : '',
  });

  if (isError) {
    return <EmptyStateCard message="shared.emptyStateText" />;
  }

  if (isEmpty) {
    return <EmptyStateCard />;
  }

  return (
    <ListingsList
      skeletonKey={`${feedRequest.feedType}-listings`}
      listings={listings}
      isLoading={isLoading}
      onClickListing={() => trackClickFeedItem(feedRequest.feedType)}
      visualization={visualization}
    />
  );
};

export default FeedItems;
